import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useReducer, useCallback, useMemo } from 'react';
import { createPortal } from 'react-dom';
import ModalComponent from './component';
import { ModalHeader } from './header';
const initialState = {
    visible: false,
    Body: _jsx(_Fragment, {}),
    title: '',
};
function reducer(state, action) {
    switch (action.type) {
        case 'OPEN': {
            return Object.assign(Object.assign({}, action.payload), { visible: true });
        }
        case 'CLOSE':
            return initialState;
        case 'SET_BODY':
            return Object.assign(Object.assign({}, state), { Body: action.payload });
        case 'SET_FOOTER':
            return Object.assign(Object.assign({}, state), { Footer: action.payload });
        case 'SET_OPTIONS':
            return Object.assign(Object.assign({}, state), { options: action.payload });
        default:
            return state;
    }
}
export function useModal() {
    const [state, dispatch] = useReducer(reducer, initialState);
    const open = useCallback((payload) => {
        dispatch({ type: 'OPEN', payload });
    }, []);
    const close = useCallback(() => {
        dispatch({ type: 'CLOSE' });
    }, []);
    const Modal = useMemo(() => () => state.visible
        ? // Portal is needed here because when the open opens in/from a table, it captures the fixed position
            createPortal(_jsx(ModalComponent, { visible: state.visible, onClose: close, Header: state.Header ? (state.Header) : state.title ? (_jsx(ModalHeader, { title: state.title, subtitle: state.subtitle })) : null, Body: state.Body, Footer: state.Footer, options: state.options }), 
            // @ts-expect-error This is web only
            document.getElementById('modal-root'))
        : null, [close, state]);
    return {
        Modal,
        open,
        close,
        setBody: (b) => dispatch({ type: 'SET_BODY', payload: b }),
        setFooter: (f) => dispatch({ type: 'SET_FOOTER', payload: f }),
        setOptions: (o) => dispatch({ type: 'SET_OPTIONS', payload: o }),
    };
}
